<template>
  <v-container>
    <v-container>
      <v-autocomplete
        v-if="user.isAdmin || user.isRegionalApprover || user.isRegionalAdmin"
        v-model="state"
        @change="updateState"
        :items="
          user.isAdmin
            ? filteredStates
            : user.isRegionalApprover || user.isRegionalAdmin
            ? sortedRegionalStates
            : user.state
        "
        :search-input.sync="search"
        :disabled="disabled"
        cache-items
        item-text="name"
        item-value="name"
        prepend-icon="mdi-map-marker-outline"
        label="State"
        multiple
        chips
        deletable-chips
        dense
        clearable
      />
    </v-container>
  </v-container>
</template>

<script>
import { states } from 'utils';
import { mapState } from 'vuex';

export default {
  name: 'StatePickerMultiple',

  props: {
    selectedStates: {
      type: Array,
      default: () => [],
    },
    includeNational: {
      type: Boolean,
      default: () => true,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      states,
      search: null,
      state: [],
    };
  },

  computed: {
    ...mapState(['user']),

    filteredStates() {
      if (!this.includeNational) {
        // The first item in the states object is National. Return the object but without that value.
        return [...states].slice(1);
      }

      return states;
    },

    sortedRegionalStates() {
      //Return regional approver and admin states in alphabetical order
      let regionalStates = [];
      if (this.user.isRegionalAdmin || this.user.isRegionalApprover) {
        regionalStates = [...this.user.regionalAdminStates];
      }
      /**
       *If an action or post already has state values outside of a regional approver's states,
       *it will include those states as well because approvers can access posts and actions
       * as long as they have one state in common with the post or action
       */
      const states = [...this.state, ...regionalStates];
      const sortedRegionalStates = states.sort();
      return sortedRegionalStates;
    },
  },

  watch: {
    state() {
      this.search = '';
    },
  },

  created() {
    this.state = [...this.selectedStates];
  },

  methods: {
    updateState() {
      this.$emit('updateStates', this.state);
    },
  },
};
</script>
